<div class="profile-wrapper" [ngClass]="{ 'mx-3' : isMobile | async }">
  <div class="card shadow-sm">
    <div class="card-body" style="overflow-x: hidden;">
      <div *ngIf="profile | async as person; else loading" class="row">
        <div class="col-md-4">
          <img class="img-fluid profile-img shadow-sm" [src]="person.photoThumb ? person.photoThumb : dummyPhoto"
            alt="Profile Image">
          <div class="d-flex flex-column mt-3 intro">
            <ng-container *ngIf="person.preferredName; else notPreferred">
              <h5>{{ person.preferredName }}, {{ person.honorific }}</h5>
            </ng-container>
            <ng-template #notPreferred>
              <h5>{{ person.firstname }} {{ person.lastname }}, {{ person.honorific }}</h5>
            </ng-template>
            <span [innerHTML]="person.position"></span>
            <a
              [routerLink]="['/directory', 'department=' + person.primaryDepartment]">{{ person.primaryDepartment }}</a>
            <a [routerLink]="['/directory', 'school=' + person.primarySchool]">{{ person.primarySchool }}</a>
            <span>{{ person.phone }}</span>
            <a [href]="'mailto:' + person.email">{{ person.email }}</a>
            <!-- <a [href]="formatPureProfileLink(person.firstname, person.lastname)"
                target="_blank">Research Profile</a> -->
          </div>
        </div>

        <div *ngIf="!isQuestion" class="col-md-8 profile-content">
          <nav class="nav nav-pills nav-fill shadow-sm" #navRef
            [ngStyle]="{ 'display':(isMobile | async) ? 'none' : '' }">
            <span *ngIf="person.biography.length > 1" class="nav-item nav-link" [ngClass]="{'active' : activeTab === 0}"
              (click)="setActiveTab(0)">Biography</span>
            <span *ngIf="person.interests > 0" class="nav-item nav-link" [ngClass]="{'active' : activeTab === 1}"
              (click)="setActiveTab(1)">Interests</span>
            <span *ngIf="person.degrees > 0" class="nav-item nav-link" [ngClass]="{'active' : activeTab === 2}"
              (click)="setActiveTab(2)">Degrees</span>
            <span *ngIf="person.certifications > 0" class="nav-item nav-link" [ngClass]="{'active' : activeTab === 3}"
              (click)="setActiveTab(3)">Certifications</span>
            <span *ngIf="person.honors > 0" class="nav-item nav-link" [ngClass]="{'active' : activeTab === 4}"
              (click)="setActiveTab(4)">Honors</span>
            <span *ngIf="person.licensures > 0" class="nav-item nav-link" [ngClass]="{'active' : activeTab === 5}"
              (click)="setActiveTab(5)">Licensures</span>
            <span *ngIf="person.journals > 0" class="nav-item nav-link" [ngClass]="{'active' : activeTab === 6}"
              (click)="setActiveTab(6)">Publications</span>
          </nav>

          <app-profile-biography *ngIf="activeTab === 0 || ((isMobile | async) && person.biography.length > 1 )"
            [biography]="person.biography"></app-profile-biography>
          <app-profile-interest *ngIf="activeTab === 1 || ((isMobile | async) && person.interests > 0)"
            [interests]="interests"></app-profile-interest>
          <app-profile-degree *ngIf="activeTab === 2 || ((isMobile | async) && person.degrees > 0)" [degrees]="degrees">
          </app-profile-degree>
          <app-profile-certification *ngIf="activeTab === 3 || ((isMobile | async) && person.certifications > 0)"
            [certifications]="certifications">
          </app-profile-certification>
          <app-profile-honor *ngIf="activeTab === 4 || ((isMobile | async) && person.honors > 0)" [honors]="honors">
          </app-profile-honor>
          <app-profile-licensure *ngIf="activeTab === 5 || ((isMobile | async) && person.licensures > 0)"
            [licensures]="licensures"></app-profile-licensure>
          <app-profile-journal *ngIf="activeTab === 6 || ((isMobile | async) && person.journals > 0)"
            [journals]="journals"></app-profile-journal>
        </div>

        <div *ngIf="isQuestion" class="col-md-8 profile-content p-3">
          <h4 class="border-bottom-1">Profile Help</h4>
          <p>
            Information for the Faculty Profile is pulled from UNT Health Fort Worth Interfolio Faculty 180. Faculty are strongly
            encouraged to keep
            their UNT Health Fort Worth Interfolio Faculty 180 data up to date. More information on how to update your faculty profile in UNT Health Fort Worth
            Interfolio
            can be found at <a href="https://www.unthsc.edu/academic-affairs/faculty-affairs/hsc-interfolio/"
              target="_blank">https://www.unthsc.edu/academic-affairs/faculty-affairs/hsc-interfolio/</a>.
          </p>
          <button type="button" class="btn btn-outline-secondary btn-sm shadow-sm" (click)="isQuestion = false">Close
            Help</button>
        </div>
      </div>
      <ng-template #loading>
        <app-profile-skeleton></app-profile-skeleton>
      </ng-template>
    </div>

    <div *ngIf="!isQuestion" class="card-footer text-right">
      <a href="javascript:void(0)" (click)="isQuestion = true" class="card-link">
        <fa-icon [icon]="faQuestionCircle"></fa-icon> Profile Help
      </a>
    </div>
  </div>
</div>